module.exports = __webpack_public_path__ + "static/media/Poop-Small-Smile-Look.424294ca.png";